import styled from "styled-components";
import PropTypes from "prop-types";

export const Container = styled.div`
    width: ${props => props.width};
`;

Container.propTypes = {
    width: PropTypes.string
};
